import { render, staticRenderFns } from "./viewContacts.vue?vue&type=template&id=51ba3d2c&scoped=true"
import script from "./viewContacts.vue?vue&type=script&lang=js"
export * from "./viewContacts.vue?vue&type=script&lang=js"
import style0 from "./viewContacts.vue?vue&type=style&index=0&id=51ba3d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba3d2c",
  null
  
)

export default component.exports